// Curated Remix (ri) icons, each with a `line` and `fill` class. The class
// literals are kept here so Tailwind generates them. { name, keywords, line, fill }

export const CURATED_ICONS = [
  {
    name: 'home',
    keywords: 'home house main',
    line: 'i-ri-home-line',
    fill: 'i-ri-home-fill',
  },
  {
    name: 'star',
    keywords: 'favorite star',
    line: 'i-ri-star-line',
    fill: 'i-ri-star-fill',
  },
  {
    name: 'heart',
    keywords: 'like love',
    line: 'i-ri-heart-line',
    fill: 'i-ri-heart-fill',
  },
  {
    name: 'bookmark',
    keywords: 'save',
    line: 'i-ri-bookmark-line',
    fill: 'i-ri-bookmark-fill',
  },
  {
    name: 'flag-2',
    keywords: 'flag report',
    line: 'i-ri-flag-2-line',
    fill: 'i-ri-flag-2-fill',
  },
  {
    name: 'price-tag-3',
    keywords: 'tag label',
    line: 'i-ri-price-tag-3-line',
    fill: 'i-ri-price-tag-3-fill',
  },
  {
    name: 'map-pin',
    keywords: 'location place',
    line: 'i-ri-map-pin-line',
    fill: 'i-ri-map-pin-fill',
  },
  {
    name: 'sparkling-2',
    keywords: 'magic ai shine sparkle',
    line: 'i-ri-sparkling-2-line',
    fill: 'i-ri-sparkling-2-fill',
  },
  {
    name: 'fire',
    keywords: 'flame hot trending',
    line: 'i-ri-fire-line',
    fill: 'i-ri-fire-fill',
  },
  {
    name: 'lightbulb',
    keywords: 'idea tip',
    line: 'i-ri-lightbulb-line',
    fill: 'i-ri-lightbulb-fill',
  },
  {
    name: 'rocket',
    keywords: 'launch startup ship',
    line: 'i-ri-rocket-line',
    fill: 'i-ri-rocket-fill',
  },
  {
    name: 'focus-3',
    keywords: 'target goal aim',
    line: 'i-ri-focus-3-line',
    fill: 'i-ri-focus-3-fill',
  },
  {
    name: 'award',
    keywords: 'prize badge medal',
    line: 'i-ri-award-line',
    fill: 'i-ri-award-fill',
  },
  {
    name: 'trophy',
    keywords: 'win achievement',
    line: 'i-ri-trophy-line',
    fill: 'i-ri-trophy-fill',
  },
  {
    name: 'vip-crown-2',
    keywords: 'crown premium vip',
    line: 'i-ri-vip-crown-2-line',
    fill: 'i-ri-vip-crown-2-fill',
  },
  {
    name: 'vip-diamond',
    keywords: 'gem diamond premium',
    line: 'i-ri-vip-diamond-line',
    fill: 'i-ri-vip-diamond-fill',
  },
  {
    name: 'gift',
    keywords: 'present reward',
    line: 'i-ri-gift-line',
    fill: 'i-ri-gift-fill',
  },
  {
    name: 'notification-3',
    keywords: 'bell alert',
    line: 'i-ri-notification-3-line',
    fill: 'i-ri-notification-3-fill',
  },
  {
    name: 'global',
    keywords: 'globe world web',
    line: 'i-ri-global-line',
    fill: 'i-ri-global-fill',
  },
  {
    name: 'compass-3',
    keywords: 'explore discover',
    line: 'i-ri-compass-3-line',
    fill: 'i-ri-compass-3-fill',
  },
  {
    name: 'puzzle-2',
    keywords: 'extension integration',
    line: 'i-ri-puzzle-2-line',
    fill: 'i-ri-puzzle-2-fill',
  },
  {
    name: 'ticket-2',
    keywords: 'support coupon',
    line: 'i-ri-ticket-2-line',
    fill: 'i-ri-ticket-2-fill',
  },
  {
    name: 'megaphone',
    keywords: 'announce broadcast marketing',
    line: 'i-ri-megaphone-line',
    fill: 'i-ri-megaphone-fill',
  },
  {
    name: 'briefcase-4',
    keywords: 'work job business',
    line: 'i-ri-briefcase-4-line',
    fill: 'i-ri-briefcase-4-fill',
  },
  {
    name: 'building-2',
    keywords: 'company office org',
    line: 'i-ri-building-2-line',
    fill: 'i-ri-building-2-fill',
  },
  {
    name: 'store-2',
    keywords: 'shop commerce',
    line: 'i-ri-store-2-line',
    fill: 'i-ri-store-2-fill',
  },
  {
    name: 'community',
    keywords: 'group team',
    line: 'i-ri-community-line',
    fill: 'i-ri-community-fill',
  },
  {
    name: 'folder',
    keywords: 'directory',
    line: 'i-ri-folder-line',
    fill: 'i-ri-folder-fill',
  },
  {
    name: 'folder-open',
    keywords: 'directory open',
    line: 'i-ri-folder-open-line',
    fill: 'i-ri-folder-open-fill',
  },
  {
    name: 'file',
    keywords: 'document',
    line: 'i-ri-file-line',
    fill: 'i-ri-file-fill',
  },
  {
    name: 'file-text',
    keywords: 'document doc',
    line: 'i-ri-file-text-line',
    fill: 'i-ri-file-text-fill',
  },
  {
    name: 'file-copy',
    keywords: 'documents files',
    line: 'i-ri-file-copy-line',
    fill: 'i-ri-file-copy-fill',
  },
  {
    name: 'clipboard',
    keywords: 'copy tasks',
    line: 'i-ri-clipboard-line',
    fill: 'i-ri-clipboard-fill',
  },
  {
    name: 'book-2',
    keywords: 'read guide book',
    line: 'i-ri-book-2-line',
    fill: 'i-ri-book-2-fill',
  },
  {
    name: 'book-open',
    keywords: 'read guide docs',
    line: 'i-ri-book-open-line',
    fill: 'i-ri-book-open-fill',
  },
  {
    name: 'graduation-cap',
    keywords: 'learn course education',
    line: 'i-ri-graduation-cap-line',
    fill: 'i-ri-graduation-cap-fill',
  },
  {
    name: 'newspaper',
    keywords: 'news article blog',
    line: 'i-ri-newspaper-line',
    fill: 'i-ri-newspaper-fill',
  },
  {
    name: 'sticky-note',
    keywords: 'note memo',
    line: 'i-ri-sticky-note-line',
    fill: 'i-ri-sticky-note-fill',
  },
  {
    name: 'pencil',
    keywords: 'write edit',
    line: 'i-ri-pencil-line',
    fill: 'i-ri-pencil-fill',
  },
  {
    name: 'quill-pen',
    keywords: 'write author',
    line: 'i-ri-quill-pen-line',
    fill: 'i-ri-quill-pen-fill',
  },
  {
    name: 'mark-pen',
    keywords: 'highlight',
    line: 'i-ri-mark-pen-line',
    fill: 'i-ri-mark-pen-fill',
  },
  {
    name: 'calendar-2',
    keywords: 'date schedule calendar',
    line: 'i-ri-calendar-2-line',
    fill: 'i-ri-calendar-2-fill',
  },
  {
    name: 'calendar-event',
    keywords: 'schedule event',
    line: 'i-ri-calendar-event-line',
    fill: 'i-ri-calendar-event-fill',
  },
  {
    name: 'time',
    keywords: 'clock time',
    line: 'i-ri-time-line',
    fill: 'i-ri-time-fill',
  },
  {
    name: 'timer',
    keywords: 'countdown',
    line: 'i-ri-timer-line',
    fill: 'i-ri-timer-fill',
  },
  {
    name: 'history',
    keywords: 'recent past',
    line: 'i-ri-history-line',
    fill: 'i-ri-history-fill',
  },
  {
    name: 'hourglass',
    keywords: 'wait time',
    line: 'i-ri-hourglass-line',
    fill: 'i-ri-hourglass-fill',
  },
  {
    name: 'shopping-cart-2',
    keywords: 'buy ecommerce cart',
    line: 'i-ri-shopping-cart-2-line',
    fill: 'i-ri-shopping-cart-2-fill',
  },
  {
    name: 'shopping-bag-3',
    keywords: 'buy purchase bag',
    line: 'i-ri-shopping-bag-3-line',
    fill: 'i-ri-shopping-bag-3-fill',
  },
  {
    name: 'box-3',
    keywords: 'package box shipping',
    line: 'i-ri-box-3-line',
    fill: 'i-ri-box-3-fill',
  },
  {
    name: 'archive',
    keywords: 'store box archive',
    line: 'i-ri-archive-line',
    fill: 'i-ri-archive-fill',
  },
  {
    name: 'bank-card',
    keywords: 'pay billing card credit',
    line: 'i-ri-bank-card-line',
    fill: 'i-ri-bank-card-fill',
  },
  {
    name: 'wallet-3',
    keywords: 'money pay wallet',
    line: 'i-ri-wallet-3-line',
    fill: 'i-ri-wallet-3-fill',
  },
  {
    name: 'money-dollar-circle',
    keywords: 'money price usd',
    line: 'i-ri-money-dollar-circle-line',
    fill: 'i-ri-money-dollar-circle-fill',
  },
  {
    name: 'copper-coin',
    keywords: 'coins money',
    line: 'i-ri-copper-coin-line',
    fill: 'i-ri-copper-coin-fill',
  },
  {
    name: 'currency',
    keywords: 'money exchange',
    line: 'i-ri-currency-line',
    fill: 'i-ri-currency-fill',
  },
  {
    name: 'receipt',
    keywords: 'invoice bill',
    line: 'i-ri-receipt-line',
    fill: 'i-ri-receipt-fill',
  },
  {
    name: 'percent',
    keywords: 'discount sale',
    line: 'i-ri-percent-line',
    fill: 'i-ri-percent-fill',
  },
  {
    name: 'calculator',
    keywords: 'math',
    line: 'i-ri-calculator-line',
    fill: 'i-ri-calculator-fill',
  },
  {
    name: 'mail',
    keywords: 'email message',
    line: 'i-ri-mail-line',
    fill: 'i-ri-mail-fill',
  },
  {
    name: 'send-plane',
    keywords: 'send submit',
    line: 'i-ri-send-plane-line',
    fill: 'i-ri-send-plane-fill',
  },
  {
    name: 'chat-3',
    keywords: 'chat talk message',
    line: 'i-ri-chat-3-line',
    fill: 'i-ri-chat-3-fill',
  },
  {
    name: 'message-2',
    keywords: 'chat comment',
    line: 'i-ri-message-2-line',
    fill: 'i-ri-message-2-fill',
  },
  {
    name: 'question-answer',
    keywords: 'chat conversation faq',
    line: 'i-ri-question-answer-line',
    fill: 'i-ri-question-answer-fill',
  },
  {
    name: 'phone',
    keywords: 'call',
    line: 'i-ri-phone-line',
    fill: 'i-ri-phone-fill',
  },
  {
    name: 'vidicon',
    keywords: 'video call meeting',
    line: 'i-ri-vidicon-line',
    fill: 'i-ri-vidicon-fill',
  },
  {
    name: 'mic',
    keywords: 'record voice audio',
    line: 'i-ri-mic-line',
    fill: 'i-ri-mic-fill',
  },
  {
    name: 'group',
    keywords: 'team people users',
    line: 'i-ri-group-line',
    fill: 'i-ri-group-fill',
  },
  {
    name: 'user',
    keywords: 'person account',
    line: 'i-ri-user-line',
    fill: 'i-ri-user-fill',
  },
  {
    name: 'user-add',
    keywords: 'add member',
    line: 'i-ri-user-add-line',
    fill: 'i-ri-user-add-fill',
  },
  {
    name: 'contacts',
    keywords: 'person card contact',
    line: 'i-ri-contacts-line',
    fill: 'i-ri-contacts-fill',
  },
  {
    name: 'emotion-happy',
    keywords: 'happy smile emoji',
    line: 'i-ri-emotion-happy-line',
    fill: 'i-ri-emotion-happy-fill',
  },
  {
    name: 'thumb-up',
    keywords: 'like approve',
    line: 'i-ri-thumb-up-line',
    fill: 'i-ri-thumb-up-fill',
  },
  {
    name: 'hand-heart',
    keywords: 'care support',
    line: 'i-ri-hand-heart-line',
    fill: 'i-ri-hand-heart-fill',
  },
  {
    name: 'at',
    keywords: 'mention email at',
    line: 'i-ri-at-line',
    fill: 'i-ri-at-fill',
  },
  {
    name: 'image-2',
    keywords: 'picture photo image',
    line: 'i-ri-image-2-line',
    fill: 'i-ri-image-2-fill',
  },
  {
    name: 'camera-3',
    keywords: 'photo camera',
    line: 'i-ri-camera-3-line',
    fill: 'i-ri-camera-3-fill',
  },
  {
    name: 'film',
    keywords: 'movie video',
    line: 'i-ri-film-line',
    fill: 'i-ri-film-fill',
  },
  {
    name: 'music-2',
    keywords: 'audio song music',
    line: 'i-ri-music-2-line',
    fill: 'i-ri-music-2-fill',
  },
  {
    name: 'headphone',
    keywords: 'audio support',
    line: 'i-ri-headphone-line',
    fill: 'i-ri-headphone-fill',
  },
  {
    name: 'palette',
    keywords: 'color design art',
    line: 'i-ri-palette-line',
    fill: 'i-ri-palette-fill',
  },
  {
    name: 'brush-3',
    keywords: 'paint design brush',
    line: 'i-ri-brush-3-line',
    fill: 'i-ri-brush-3-fill',
  },
  {
    name: 'scissors-2',
    keywords: 'cut',
    line: 'i-ri-scissors-2-line',
    fill: 'i-ri-scissors-2-fill',
  },
  {
    name: 'code-s-slash',
    keywords: 'develop code programming',
    line: 'i-ri-code-s-slash-line',
    fill: 'i-ri-code-s-slash-fill',
  },
  {
    name: 'terminal-box',
    keywords: 'console cli terminal',
    line: 'i-ri-terminal-box-line',
    fill: 'i-ri-terminal-box-fill',
  },
  {
    name: 'git-branch',
    keywords: 'version code git',
    line: 'i-ri-git-branch-line',
    fill: 'i-ri-git-branch-fill',
  },
  {
    name: 'github',
    keywords: 'git code',
    line: 'i-ri-github-line',
    fill: 'i-ri-github-fill',
  },
  {
    name: 'cpu',
    keywords: 'chip processor',
    line: 'i-ri-cpu-line',
    fill: 'i-ri-cpu-fill',
  },
  {
    name: 'database-2',
    keywords: 'storage data',
    line: 'i-ri-database-2-line',
    fill: 'i-ri-database-2-fill',
  },
  {
    name: 'server',
    keywords: 'host backend',
    line: 'i-ri-server-line',
    fill: 'i-ri-server-fill',
  },
  {
    name: 'cloud',
    keywords: 'storage cloud',
    line: 'i-ri-cloud-line',
    fill: 'i-ri-cloud-fill',
  },
  {
    name: 'wifi',
    keywords: 'network internet',
    line: 'i-ri-wifi-line',
    fill: 'i-ri-wifi-fill',
  },
  {
    name: 'computer',
    keywords: 'screen desktop monitor',
    line: 'i-ri-computer-line',
    fill: 'i-ri-computer-fill',
  },
  {
    name: 'smartphone',
    keywords: 'mobile phone',
    line: 'i-ri-smartphone-line',
    fill: 'i-ri-smartphone-fill',
  },
  {
    name: 'macbook',
    keywords: 'laptop computer',
    line: 'i-ri-macbook-line',
    fill: 'i-ri-macbook-fill',
  },
  {
    name: 'bug',
    keywords: 'issue error bug',
    line: 'i-ri-bug-line',
    fill: 'i-ri-bug-fill',
  },
  {
    name: 'command',
    keywords: 'keyboard shortcut',
    line: 'i-ri-command-line',
    fill: 'i-ri-command-fill',
  },
  {
    name: 'settings-3',
    keywords: 'config gear options settings',
    line: 'i-ri-settings-3-line',
    fill: 'i-ri-settings-3-fill',
  },
  {
    name: 'equalizer',
    keywords: 'controls adjust sliders filter',
    line: 'i-ri-equalizer-line',
    fill: 'i-ri-equalizer-fill',
  },
  {
    name: 'tools',
    keywords: 'fix tools config',
    line: 'i-ri-tools-line',
    fill: 'i-ri-tools-fill',
  },
  {
    name: 'hammer',
    keywords: 'build fix hammer',
    line: 'i-ri-hammer-line',
    fill: 'i-ri-hammer-fill',
  },
  {
    name: 'key-2',
    keywords: 'password access key',
    line: 'i-ri-key-2-line',
    fill: 'i-ri-key-2-fill',
  },
  {
    name: 'lock',
    keywords: 'secure private lock',
    line: 'i-ri-lock-line',
    fill: 'i-ri-lock-fill',
  },
  {
    name: 'lock-unlock',
    keywords: 'open access',
    line: 'i-ri-lock-unlock-line',
    fill: 'i-ri-lock-unlock-fill',
  },
  {
    name: 'shield',
    keywords: 'security protect',
    line: 'i-ri-shield-line',
    fill: 'i-ri-shield-fill',
  },
  {
    name: 'shield-check',
    keywords: 'secure verified',
    line: 'i-ri-shield-check-line',
    fill: 'i-ri-shield-check-fill',
  },
  {
    name: 'eye',
    keywords: 'view visible preview',
    line: 'i-ri-eye-line',
    fill: 'i-ri-eye-fill',
  },
  {
    name: 'search',
    keywords: 'find lookup search',
    line: 'i-ri-search-line',
    fill: 'i-ri-search-fill',
  },
  {
    name: 'filter-3',
    keywords: 'sort refine filter',
    line: 'i-ri-filter-3-line',
    fill: 'i-ri-filter-3-fill',
  },
  {
    name: 'links',
    keywords: 'url chain link',
    line: 'i-ri-links-line',
    fill: 'i-ri-links-fill',
  },
  {
    name: 'share-forward',
    keywords: 'share send distribute',
    line: 'i-ri-share-forward-line',
    fill: 'i-ri-share-forward-fill',
  },
  {
    name: 'plug',
    keywords: 'connect integration',
    line: 'i-ri-plug-line',
    fill: 'i-ri-plug-fill',
  },
  {
    name: 'shut-down',
    keywords: 'power on off',
    line: 'i-ri-shut-down-line',
    fill: 'i-ri-shut-down-fill',
  },
  {
    name: 'qr-scan-2',
    keywords: 'qr scan',
    line: 'i-ri-qr-scan-2-line',
    fill: 'i-ri-qr-scan-2-fill',
  },
  {
    name: 'fingerprint',
    keywords: 'identity auth fingerprint',
    line: 'i-ri-fingerprint-line',
    fill: 'i-ri-fingerprint-fill',
  },
  {
    name: 'bar-chart',
    keywords: 'analytics stats graph bar',
    line: 'i-ri-bar-chart-line',
    fill: 'i-ri-bar-chart-fill',
  },
  {
    name: 'pie-chart',
    keywords: 'analytics stats pie',
    line: 'i-ri-pie-chart-line',
    fill: 'i-ri-pie-chart-fill',
  },
  {
    name: 'line-chart',
    keywords: 'analytics trend graph line',
    line: 'i-ri-line-chart-line',
    fill: 'i-ri-line-chart-fill',
  },
  {
    name: 'stock',
    keywords: 'growth increase trending',
    line: 'i-ri-stock-line',
    fill: 'i-ri-stock-fill',
  },
  {
    name: 'pulse',
    keywords: 'activity health monitor',
    line: 'i-ri-pulse-line',
    fill: 'i-ri-pulse-fill',
  },
  {
    name: 'dashboard-3',
    keywords: 'speed performance dashboard gauge',
    line: 'i-ri-dashboard-3-line',
    fill: 'i-ri-dashboard-3-fill',
  },
  {
    name: 'check',
    keywords: 'done complete ok check',
    line: 'i-ri-check-line',
    fill: 'i-ri-check-fill',
  },
  {
    name: 'checkbox-circle',
    keywords: 'done success check',
    line: 'i-ri-checkbox-circle-line',
    fill: 'i-ri-checkbox-circle-fill',
  },
  {
    name: 'close-circle',
    keywords: 'error fail close',
    line: 'i-ri-close-circle-line',
    fill: 'i-ri-close-circle-fill',
  },
  {
    name: 'information',
    keywords: 'info information',
    line: 'i-ri-information-line',
    fill: 'i-ri-information-fill',
  },
  {
    name: 'error-warning',
    keywords: 'warning alert',
    line: 'i-ri-error-warning-line',
    fill: 'i-ri-error-warning-fill',
  },
  {
    name: 'alert',
    keywords: 'warning caution',
    line: 'i-ri-alert-line',
    fill: 'i-ri-alert-fill',
  },
  {
    name: 'question',
    keywords: 'support faq help',
    line: 'i-ri-question-line',
    fill: 'i-ri-question-fill',
  },
  {
    name: 'layout-grid',
    keywords: 'dashboard apps grid',
    line: 'i-ri-layout-grid-line',
    fill: 'i-ri-layout-grid-fill',
  },
  {
    name: 'table',
    keywords: 'grid data table',
    line: 'i-ri-table-line',
    fill: 'i-ri-table-fill',
  },
  {
    name: 'function',
    keywords: 'kanban board',
    line: 'i-ri-function-line',
    fill: 'i-ri-function-fill',
  },
  {
    name: 'map-2',
    keywords: 'location navigate map',
    line: 'i-ri-map-2-line',
    fill: 'i-ri-map-2-fill',
  },
  {
    name: 'navigation',
    keywords: 'direction gps',
    line: 'i-ri-navigation-line',
    fill: 'i-ri-navigation-fill',
  },
  {
    name: 'car',
    keywords: 'drive vehicle car',
    line: 'i-ri-car-line',
    fill: 'i-ri-car-fill',
  },
  {
    name: 'truck',
    keywords: 'delivery shipping',
    line: 'i-ri-truck-line',
    fill: 'i-ri-truck-fill',
  },
  {
    name: 'plane',
    keywords: 'travel flight plane',
    line: 'i-ri-plane-line',
    fill: 'i-ri-plane-fill',
  },
  {
    name: 'bike',
    keywords: 'cycle bike',
    line: 'i-ri-bike-line',
    fill: 'i-ri-bike-fill',
  },
  {
    name: 'anchor',
    keywords: 'ship marine anchor',
    line: 'i-ri-anchor-line',
    fill: 'i-ri-anchor-fill',
  },
  {
    name: 'leaf',
    keywords: 'eco nature green leaf',
    line: 'i-ri-leaf-line',
    fill: 'i-ri-leaf-fill',
  },
  {
    name: 'plant',
    keywords: 'nature plant grow',
    line: 'i-ri-plant-line',
    fill: 'i-ri-plant-fill',
  },
  {
    name: 'sun',
    keywords: 'day light weather sun',
    line: 'i-ri-sun-line',
    fill: 'i-ri-sun-fill',
  },
  {
    name: 'moon',
    keywords: 'night dark moon',
    line: 'i-ri-moon-line',
    fill: 'i-ri-moon-fill',
  },
  {
    name: 'rainy',
    keywords: 'weather rain',
    line: 'i-ri-rainy-line',
    fill: 'i-ri-rainy-fill',
  },
  {
    name: 'umbrella',
    keywords: 'rain protect umbrella',
    line: 'i-ri-umbrella-line',
    fill: 'i-ri-umbrella-fill',
  },
  {
    name: 'landscape',
    keywords: 'outdoor hike mountain',
    line: 'i-ri-landscape-line',
    fill: 'i-ri-landscape-fill',
  },
  {
    name: 'drop',
    keywords: 'water drop',
    line: 'i-ri-drop-line',
    fill: 'i-ri-drop-fill',
  },
  {
    name: 'cup',
    keywords: 'coffee drink cup',
    line: 'i-ri-cup-line',
    fill: 'i-ri-cup-fill',
  },
  {
    name: 'restaurant',
    keywords: 'food eat restaurant',
    line: 'i-ri-restaurant-line',
    fill: 'i-ri-restaurant-fill',
  },
  {
    name: 'cake-3',
    keywords: 'birthday celebrate cake',
    line: 'i-ri-cake-3-line',
    fill: 'i-ri-cake-3-fill',
  },
  {
    name: 'goblet',
    keywords: 'drink wine bar',
    line: 'i-ri-goblet-line',
    fill: 'i-ri-goblet-fill',
  },
  {
    name: 'heart-pulse',
    keywords: 'health medical',
    line: 'i-ri-heart-pulse-line',
    fill: 'i-ri-heart-pulse-fill',
  },
  {
    name: 'stethoscope',
    keywords: 'health doctor medical',
    line: 'i-ri-stethoscope-line',
    fill: 'i-ri-stethoscope-fill',
  },
  {
    name: 'capsule',
    keywords: 'medicine pill health',
    line: 'i-ri-capsule-line',
    fill: 'i-ri-capsule-fill',
  },
  {
    name: 'add',
    keywords: 'add new create plus',
    line: 'i-ri-add-line',
    fill: 'i-ri-add-fill',
  },
  {
    name: 'delete-bin',
    keywords: 'delete remove trash',
    line: 'i-ri-delete-bin-line',
    fill: 'i-ri-delete-bin-fill',
  },
  {
    name: 'download',
    keywords: 'save export download',
    line: 'i-ri-download-line',
    fill: 'i-ri-download-fill',
  },
  {
    name: 'upload',
    keywords: 'import upload',
    line: 'i-ri-upload-line',
    fill: 'i-ri-upload-fill',
  },
  {
    name: 'refresh',
    keywords: 'reload sync update refresh',
    line: 'i-ri-refresh-line',
    fill: 'i-ri-refresh-fill',
  },
  {
    name: 'external-link',
    keywords: 'open new external',
    line: 'i-ri-external-link-line',
    fill: 'i-ri-external-link-fill',
  },
  {
    name: 'logout-box',
    keywords: 'exit signout logout',
    line: 'i-ri-logout-box-line',
    fill: 'i-ri-logout-box-fill',
  },
  {
    name: 'fullscreen',
    keywords: 'expand maximize fullscreen',
    line: 'i-ri-fullscreen-line',
    fill: 'i-ri-fullscreen-fill',
  },
  {
    name: 'drag-move',
    keywords: 'drag reorder move',
    line: 'i-ri-drag-move-line',
    fill: 'i-ri-drag-move-fill',
  },
  {
    name: 'paint-brush',
    keywords: 'brush paint',
    line: 'i-ri-paint-brush-line',
    fill: 'i-ri-paint-brush-fill',
  },
];
